import { getEventModule } from './get.module';
import { ObjectsType } from '../objects/get.module';

const module = getEventModule(ObjectsType.Cars);
export default module;
